import Vue from 'vue';
import App from './App.vue';
import store from './store';

import PokerChipCalculator from './plugin';
import PokerChipCalculatorConfig from './config/plugin.config';

Vue.use(PokerChipCalculator, {
    store,
    config: window.PokerChipCalculatorConfig || PokerChipCalculatorConfig,
});

Vue.config.productionTip = false;

new Vue({
    store,
    render: h => h(App),
}).$mount('#pccApp');
